import { useAppSelector } from '@user/store/hooks'
import { FEATURES } from '@sales-center/common/tenantFeatures'
import { selectTenantFeatureById } from '@user/store/tenantFeatures'

export function useCampaignTrackingEnabled() {
  const campaignTracking = useAppSelector((state) =>
    selectTenantFeatureById(state, FEATURES.CampaignTracking),
  )

  return campaignTracking?.enabled ?? false
}
